/**
 * created by mleitzell on 12/20/17.
 */
import template from "app/login/concurrent/ConcurrentLoginView.html";
import ViewModel from "app/login/concurrent/ConcurrentLoginViewModel";
import View from "app/main/MainPopUpView";
import "common/bindings/open";
import "common/bindings/reference";
import "app/widgets/Description/Description";
import "app/login/concurrent/ConcurrentLoginGrid";
import "app/widgets/PopUpWindow/PopUpWindow";

export default {

    open: function() {
        return new View(template, ViewModel).open();
    }
};
